<template>
  <div class="MR_envProRoadList" ref="MR_envProRoadList" @mouseleave="envProRoadLeave">
    <el-table
      class="envProRoadListTable"
      :data="tableData"
      max-height="580px"
      :header-cell-class-name="getHeaderCellClass"
      :header-row-class-name="getHeadRowClass"
      highlight-current-row
      :cell-class-name="getCellClass"
      :row-class-name="getRowClass"
      @row-click="rowClick"
    >
      <el-table-column type="index" width="70" label="序号"></el-table-column>
      <el-table-column label="清洁车" prop="deviceName">
        <template #default="scope">
          <div class="boxLine">
            <div class="cellFont">{{ scope.row.deviceName }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="司机" prop="driverName">
        <template #default="scope">
          <div class="boxLine">
            <div class="cellFont">{{ scope.row.driverName ? scope.row.driverName : "--" }}</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <p v-if="nomore">没有更多数据了</p>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  props: ['cleanCars'],
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      tableData: [],
      setTime1: null,
      nomore: false,
      currentPage: 10,
      showRoadTimer: null,
      showRoadTimer2: null,
      tableDataJsonParse: [],
      isRoadStatus: false
    }
  },
  inject: ['updateRoadStatus'],
  //计算属性 类似于data概念
  computed: {
    getHeaderCellClass() {
      return function (obj) {
        if (obj.columnIndex === 0) {
          return 'thClass_'
        } else {
          return 'thClass'
        }
      }
    },

    getHeadRowClass() {
      return function (obj) {
        return 'headTrClass'
      }
    },

    getCellClass() {
      return function (obj) {
        if (obj.columnIndex === 0) {
          return 'tdClass_'
        } else {
          return 'tdClass'
        }
      }
    },

    getRowClass() {
      return function (obj) {
        return 'trClass'
      }
    }
  },
  //监控data中的数据变化
  watch: {
    cleanCars: {
      handler(newVal, oldVal) {
        this.tableData = newVal
      },
      deep: true
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.tableData = this.cleanCars
  },

  unmounted() {},
  //方法集合
  methods: {
    rowClick(item) {
      console.log(item)
      this.$emit('oneDriver-click', [item])
    }
  },
  beforeUnmount() {}
}
</script>
<style lang="scss" scoped>
.MR_envProRoadList {
  height: 790px;
  width: 600px;
  pointer-events: all;
  padding-top: 62px !important;
  :deep(.envProRoadListTable) {
    background: #01132d40 !important;
    pointer-events: all;
    .boxLine {
      width: 100%;
    }
    .thClass {
      background: #01122ba6 !important;
      border-bottom: 1px solid #cccccc28 !important;
    }

    .thClass > .cell {
      font-size: 20px !important;
      color: #47ffddff !important;
      font-family: 'fontNormal' !important;
      text-align: center !important;
    }
    .thClass_ {
      background: #01122ba6 !important;
      border-right: 1px solid rgba(132, 170, 255, 0.5) !important;
      border-bottom: 1px solid #cccccc28 !important;
    }

    .thClass_ > .cell {
      font-size: 20px !important;
      color: #bbbbbbff !important;
      font-family: 'fontNormal' !important;
      text-align: center !important;
    }
    .tdClass {
      border-right: 1px solid #84aaff40 !important;
      border-bottom: 1px solid #84aaff40 !important;
      background: #01122b66 !important;
    }
    .tdClass > .cell {
      font-size: 20px !important;
      color: #bbbbbbff !important;
      font-family: 'fontNormal' !important;
      text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }
    .tdClass > .cell > .star-box {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 100%;
    }
    .tdClass_ {
      border-right: 1px solid #84aaff40 !important;
      border-bottom: 1px solid #84aaff40 !important;
      background: #0b336b40 !important;
    }

    .tdClass_ > .cell > div {
      font-size: 20px !important;
      color: #888888ff !important;
      font-family: 'fontNormal' !important;
      text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .headTrClass {
      border: 1px solid rgba(132, 170, 255, 0.5) !important;
    }
    .no-star {
      font-size: 16px;
      color: #ccc !important;
    }
    .tooltip-item {
      color: #47ffddff !important;
    }
    .cellFont {
      font-size: 18px !important;
      color: #cccccc !important;
      font-family: 'fontNormal' !important;
      text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .el-table__body-wrapper {
      &::-webkit-scrollbar {
        width: 0px !important;
      }
    }
    .el-table__body-wrapper.show {
      &::-webkit-scrollbar {
        width: 10px !important;
      }
    }
  }
}
</style>
<style>
.tooltipBox {
  color: rgb(244, 196, 143) !important;
  background: black;
  border: 2px rgb(57, 123, 247) solid;
}
.tooltipBox .el-popper__arrow::before {
  margin-top: 1px;
  border-bottom: 2px rgb(57, 123, 247) solid;
  border-right: 2px rgb(57, 123, 247) solid;
  box-sizing: border;
}
</style>
